import { render } from "./TableDocumentsDebug.vue?vue&type=template&id=5bf4289e&scoped=true"
import script from "./TableDocumentsDebug.vue?vue&type=script&lang=js"
export * from "./TableDocumentsDebug.vue?vue&type=script&lang=js"

import "./TableDocumentsDebug.vue?vue&type=style&index=0&id=5bf4289e&lang=sass&scoped=true"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf4289e"]])

export default __exports__